module.exports = __webpack_public_path__ + "media/images/soar/en/appStore-8a31eea0b7d3a24a3456b0e5095557a6.png";